var _rect, _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBandhanbanks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4074_7720",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -12,
    width: 69,
    height: 69
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8422 -11.5161L55.6628 25.7211L18.6605 56.4839L-12.1602 19.2484",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4074_7720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0024 4.97458C12.5891 5.25657 5.02344 12.9746 5.02344 22.4758C5.02344 32.1596 12.8542 40.0063 22.5049 40.0063C25.7039 40.0063 34.3901 38.6633 38.482 29.612C36.7272 30.3275 34.8097 30.7235 32.8012 30.7235C24.4663 30.7235 17.7316 25.3104 17.7202 16.9599C17.7121 12.6682 19.0067 9.21588 20.9892 6.66983C21.3909 6.1515 22.0528 5.42616 22.5049 4.96324C22.4805 4.96487 22.0268 4.97458 22.0024 4.97458Z",
    fill: "url(#paint0_linear_4074_7720)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4074_7720",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 35,
    height: 37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54688 4.96352H40.0054V40.0229H6.54688V4.96352Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4074_7720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0755 6.67012C26.6971 10.1779 27.3054 13.5307 27.3054 16.9749C27.3054 25.3253 20.5529 30.7401 12.2244 30.7401C10.2159 30.7401 8.30332 30.3424 6.54688 29.6285C10.7168 38.939 19.3168 40.0229 22.5158 40.0229C32.173 40.0229 40.0054 32.1745 40.0054 22.4924C40.0054 12.9879 32.4381 5.26989 23.0216 4.9879C22.9972 4.9879 22.5337 4.96515 22.5061 4.96352C22.9598 5.42644 23.6835 6.14037 24.0755 6.67012Z",
    fill: "url(#paint1_linear_4074_7720)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4074_7720",
    x1: 4.95838,
    y1: 6.24441,
    x2: 26.8369,
    y2: 32.5596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B131E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4074_7720",
    x1: 5.22141,
    y1: 22.4924,
    x2: 34.5182,
    y2: 22.4924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7212F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF3B23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandhanbanks);
export default __webpack_public_path__ + "static/media/bandhanbanks.6c509430c0318d3e46b9ab0a1b4121bf.svg";
export { ForwardRef as ReactComponent };